export default __webpack_public_path__ + "static/media/linkedin.11938ae4.svg";